export const IconMarker = () => (
  <svg viewBox="0 0 26 26">
    <path d="M20.94 10.11c0 4.91-7.94 13-7.94 13s-7.94-8.02-7.94-13A7.86 7.86 0 0113 2.17a7.9 7.9 0 017.94 7.94z" />
    <path d="M13 12.28a2.17 2.17 0 100-4.34 2.17 2.17 0 000 4.34z" />
  </svg>
);

export const IconAirport = () => (
  <svg viewBox="0 0 22 22">
    <path d="M14.0556 8.55539L11.6111 3.6665H7.94446L10.3889 8.55539" />
    <path d="M18.0278 8.55556H6.72224L4.8889 5.5H2.44446L4.27779 12.8333H10.7556L7.94446 18.3333H11.6111L14.4222 12.8333H18.0278C19.1889 12.8333 20.1667 11.8556 20.1667 10.6944C20.1667 9.53333 19.1889 8.55556 18.0278 8.55556Z" />
  </svg>
);

export const IconCar = () => (
  <svg viewBox="0 0 22 22">
    <path d="M19.25 9.63l-1.07-5.87a2.06 2.06 0 00-2.03-1.7H5.85c-1 0-1.85.72-2.03 1.7L2.75 9.63" />
    <path d="M6.19 16.5v3.44H2.06V16.5M19.94 16.5v3.44H15.8V16.5M21.31 16.5H.7v-3.96c0-.55.21-1.07.6-1.46l1.46-1.46h16.5l1.46 1.46c.39.39.6.91.6 1.46v3.96z" />
    <path d="M4.47 14.44a1.03 1.03 0 100-2.07 1.03 1.03 0 000 2.07zM17.53 14.44a1.03 1.03 0 100-2.07 1.03 1.03 0 000 2.07z" />
  </svg>
);

export const IconBus = () => (
  <svg fill="none" viewBox="0 0 20 20">
    <path d="M18.13 11.25H1.88M1.88 3.75h16.25" />
    <path d="M6.25 16.88v2.5H3.12v-2.5M16.88 16.88v2.5h-3.13v-2.5" />
    <path d="M18.13 16.88H1.88V2.5c0-1.04.83-1.88 1.87-1.88h12.5c1.04 0 1.88.84 1.88 1.88v14.38z" />
    <path d="M4.69 15a.94.94 0 100-1.87.94.94 0 000 1.87zM15.31 15a.94.94 0 100-1.87.94.94 0 000 1.87z" />
  </svg>
);

export const IconMetro = () => (
  <svg viewBox="0 0 22 22">
    <path d="M.69 6.19v2.06M21.31 6.19v2.06" />
    <path d="M15.81 15.81l2.69 5.5M3.5 21.31l2.69-5.5M4.84 18.56h12.32" />
    <path d="M18.56 15.81H3.44V2.75c0-1.14.92-2.06 2.06-2.06h11c1.14 0 2.06.92 2.06 2.06v13.06z" />
    <path d="M15.81 3.44H6.2v6.19h9.62v-6.2z" />
    <path d="M6.53 13.75a1.03 1.03 0 100-2.06 1.03 1.03 0 000 2.06zM15.47 13.75a1.03 1.03 0 100-2.06 1.03 1.03 0 000 2.06z" />
  </svg>
);

export const IconTaxi = () => (
  <svg viewBox="0 0 22 22">
    <path d="M8.56 4.89V2.44h4.88V4.9" />
    <path d="M18.33 11.61l-.95-5.22a1.83 1.83 0 00-1.8-1.5H6.42c-.89 0-1.65.63-1.8 1.5l-.95 5.22" />
    <path d="M6.11 17.11v2.45H3.06V17.1M18.94 17.11v2.45H15.9V17.1" />
    <path d="M20.17 17.11H1.83v-3.3c0-.6.31-1.18.82-1.52l1.02-.68h14.66l1.02.68c.51.34.82.91.82 1.53v3.3z" />
    <path d="M5.61 14.36a.42.42 0 11-.83 0 .42.42 0 01.83 0zM17.22 14.36a.42.42 0 11-.83 0 .42.42 0 01.83 0z" />
  </svg>
);

export const IconTram = () => (
  <svg viewBox="0 0 22 22">
    <path d="M14.44.69L13.06 4.8M8.94 4.81L7.56.7" />
    <path d="M.69 11v2.06M21.31 11v2.06M5.5.69h11M18.56 21.31H3.44V6.88c0-1.14.92-2.07 2.06-2.07h11c1.14 0 2.06.93 2.06 2.07V21.3z" />
    <path d="M15.81 7.56H6.2v7.57h9.62V7.55z" />
    <path d="M6.53 19.25a1.03 1.03 0 100-2.06 1.03 1.03 0 000 2.06zM15.47 19.25a1.03 1.03 0 100-2.06 1.03 1.03 0 000 2.06z" />
  </svg>
);

export const IconTrain = () => (
  <svg viewBox="0 0 32 32">
    <path d="M31 5H5C2.8 5 1 6.8 1 9v9h30M2 26h29M4 22h2M10 22h2M16 22h2M22 22h2M28 22h2M1 12h7M13 12h18" />
  </svg>
);

export const IconCityCenter = () => (
  <svg viewBox="0 0 22 22">
    <path d="M18.56 11.76V9.63M3.44 9.63v10.3h5.5v-4.8h3.44v4.8h2.06" />
    <path d="M20.63 6.88c0 1.85-1.1 2.75-2.41 2.75-1.3 0-2.4-.76-2.4-2.07 0 1.3-1.18 2.07-2.48 2.07S11 8.87 11 7.55c0 1.3-1.03 2.07-2.34 2.07-1.3 0-2.47-.76-2.47-2.07 0 1.3-1.1 2.07-2.4 2.07-1.31 0-2.42-.9-2.42-2.76L5.5.7h11l4.13 6.19zM21.31 15.13c0 2.13-3.43 5.56-3.43 5.56s-3.44-3.43-3.44-5.57a3.4 3.4 0 013.44-3.43 3.4 3.4 0 013.43 3.44z" />
    <path d="M17.88 15.81a.69.69 0 100-1.37.69.69 0 000 1.37z" />
  </svg>
);

export const IconEquippedKitchen = () => (
  <svg viewBox="0 0 22 22">
    <path d="M21.31.69H.7V21.3H21.3V.7z" />
    <path d="M17.88 7.56H4.13v10.32h13.75V7.55z" />
    <path d="M14.44 11v1.38H7.56V11M4.13 4.13H5.5M10.31 4.13h1.38M16.5 4.13h1.38" />
  </svg>
);

export const IconAirConditioning = () => (
  <svg fill="none" viewBox="0 0 22 22">
    <path d="M21.31 11.69H.7v8.94H21.3v-8.94zM17.88 17.19H4.13M11 7.56V1.38M6.19 8.94V5.5M15.81 8.94V5.5" />
  </svg>
);

export const IconWiFi = () => (
  <svg viewBox="0 0 22 22">
    <path d="M11 18.56a2.06 2.06 0 100-4.12 2.06 2.06 0 000 4.12zM16.36 11.14A7.47 7.47 0 0011 8.94a7.6 7.6 0 00-5.36 2.2M20.35 7.29A13.44 13.44 0 0011 3.44c-3.64 0-6.94 1.51-9.35 3.85" />
  </svg>
);

export const IconOnlineReception = () => (
  <svg viewBox="0 0 24 24">
    <path d="M12 5.25v-3" />
    <path d="M22.5 15.75c0-5.78-4.73-10.5-10.5-10.5-5.78 0-10.5 4.72-10.5 10.5v3h21v-3ZM1.5 21.75h21M15.75 2.25h-7.5" />
  </svg>
);

export const IconParking = () => (
  <svg viewBox="0 0 22 22">
    <path d="M21.31.69H.7V21.3H21.3V.7zM7.56 5.5v11" strokeLinecap="square" />
    <path d="M7.56 5.5h3.78a3.1 3.1 0 010 6.19H7.56" />
  </svg>
);

export const IconEarlyCheckin = () => (
  <svg viewBox="0 0 24 24">
    <path d="M18.75 19.512v3h-18V3.762h18v2.25M6 1.512v4.5M13.5 1.512v4.5" />
    <path d="M22.5 12.762h-12" />
    <path d="m19.5 15.762 3-3-3-3" />
  </svg>
);

export const IconLateCheckout = () => (
  <svg viewBox="0 0 24 24">
    <path d="M5.25 19.512v3h18V3.762h-18v2.25M18 1.512v4.5M10.5 1.512v4.5" />
    <path d="M1.5 12.762h12" />
    <path d="m4.5 15.762-3-3 3-3" />
  </svg>
);

export const IconExpressCheckIn = () => (
  <svg viewBox="0 0 22 22">
    <path d="M6.72 11.61l2.45 2.45 6.1-6.12" />
    <path d="M11 20.17a9.17 9.17 0 100-18.34 9.17 9.17 0 000 18.34z" />
  </svg>
);

export const IconTV = () => (
  <svg viewBox="0 0 22 22">
    <path d="M11 14.44V11" />
    <path d="M19.25.69H2.75V11h16.5V.69zM8.25 16.5v-2.06h5.5v2.06M21.31 21.31V16.5H.7v4.81M.69 19.25H21.3" />
  </svg>
);

export const IconLaundryIroning = () => (
  <svg viewBox="0 0 22 17">
    <path d="M11 1.75H.69V15.5H21.3c0-5.7-4.6-10.31-10.31-10.31H.69" />
  </svg>
);

export const IconPets = () => (
  <svg viewBox="0 0 22 22">
    <path d="M.69 12.3l9.86-11.21c.6-.45 1.8-.9 1.8.9v3.58l3.58 1.35 1.35 1.8 4.03 1.78-1.8 4.94-6.72 1.79-3.14 4.04" />
    <circle cx="13.15" cy="9.67" r=".86" />
  </svg>
);

export const IconReducedMobility = () => (
  <svg viewBox="0 0 22 22">
    <path d="M13.75 5.5a2.06 2.06 0 100-4.12 2.06 2.06 0 000 4.12zM8.25 19.94a4.81 4.81 0 100-9.63 4.81 4.81 0 000 9.63z" />
    <path d="M7.56 10.66l2.4-5.5c.93.34 2.69 1.23 2.41 2.06-.27.82-1.03 2.75-1.37 3.78" />
    <path d="M9.97 5.16l-2.75.68-2.4 3.1M13.06 13.4h2.4l1.38 5.5 1.72-.68" />
  </svg>
);

export const IconMapDefaultMarker = () => (
  <svg viewBox="0 0 52 53" fill="#fff">
    <path d="M41.89 20.62c0 10-15.89 26.45-15.89 26.45s-15.89-16.3-15.89-26.45c0-10.28 8.23-16.16 15.89-16.16s15.89 6.02 15.89 16.16z" />
  </svg>
);

export const IconMobileKey = () => (
  <svg viewBox="0 0 24 24">
    <path d="m12.76 13.62 1.31-1.31v-.9l-1.9-2.62-1.89 2.62V22.5A10.55 10.55 0 0 1 1.5 12.07C1.5 6.23 6.2 1.5 12 1.5s10.5 4.73 10.5 10.57c0 5.13-3.62 9.4-8.43 10.37v-4.87l-1.26-1.32 1.26-1.32-1.3-1.3Z" />
    <path d="M16.2 16.25A5.9 5.9 0 0 0 12.15 6.1 5.9 5.9 0 0 0 8.1 16.25" />
  </svg>
);

export const IconTowels = () => (
  <svg viewBox="0 0 24 24">
    <path d="M11.25 23.25h6v-20c0-1.38 1-2.5 2.25-2.5H6c-1.66 0-3 1.5-3 3.33v19.17h8.25Z" />
    <path d="M21.75 3a2.25 2.25 0 1 0-4.5 0M17.25 21h4.5V5.25" />
    <path d="M3 16.5h14.25M3 18.75h14.25" />
    <path d="M3 5.25H1.4c-.45 0-.65-.34-.65-.75s.2-.75.65-.75H3v1.5ZM17.25 3.75h5.35c.45 0 .65.34.65.75s-.2.75-.65.75h-5.35v-1.5Z" />
  </svg>
);

export const IconBarRestaurant = () => (
  <svg viewBox="0 0 24 24">
    <path d="M8.25 14.25h-3v7.5c0 .82.67 1.5 1.5 1.5s1.5-.68 1.5-1.5v-7.5ZM6.75 14.25v-6M9 .75V6c0 1.28-.97 2.25-2.25 2.25A2.21 2.21 0 0 1 4.5 6V.75M18.75 14.25h-3v7.5c0 .82.68 1.5 1.5 1.5s1.5-.68 1.5-1.5v-7.5ZM17.25 14.25V.75M20.25.75h-6v7.5h6V.75Z" />
  </svg>
);

export const IconSwimmingPool = () => (
  <svg viewBox="0 0 24 24">
    <path d="M1 20c0 2 1 3 3 3l3-1 2 1 3-1 3 1 2-1 3 1c2 0 3-1 3-3" />
    <path d="M5 19V2l1-1M20 19V2l-2-1M5 16h15M5 11h15M5 5h15" />
  </svg>
);

export const IconLocker = () => (
  <svg viewBox="0 0 24 24">
    <path d="M7.5 9.75v-4.5c0-2.48 2.03-4.5 4.5-4.5s4.5 2.02 4.5 4.5v4.5" />
    <path d="M12 23.25a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15ZM12 16.5v2.25" />
    <path d="M12 16.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" />
  </svg>
);

export const IconLuggageLockers = () => (
  <svg viewBox="0 0 24 24">
    <path d="M6 4.5h12M6 9h12M6 13.5h6M12 20.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
    <path d="M20.25 23.25H3.75a1.5 1.5 0 0 1-1.5-1.5V2.25a1.5 1.5 0 0 1 1.5-1.5h16.5a1.5 1.5 0 0 1 1.5 1.5v19.5a1.5 1.5 0 0 1-1.5 1.5Z" />
  </svg>
);

export const IconLuggageStorage = () => (
  <svg viewBox="0 0 24 24">
    <path d="M23.25 18.75a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h16.5a3 3 0 0 1 3 3v9Z" />
    <path d="M6 6.75v15m12.375-15v15M8.25 6.75V6a3 3 0 0 1 3-3h1.5a3 3 0 0 1 3 3v.75" />
  </svg>
);

export const IconBike = () => (
  <svg viewBox="0 0 24 24">
    <path d="M18.75 19.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM5.25 19.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM9 5.25H5.25" />
    <path d="m18.75 15-1.5-10.5H13.5" />
    <path d="M17.775 8.25H6.75L5.25 15" />
  </svg>
);

export const IconCommonTerrace = () => (
  <svg viewBox="0 0 24 24">
    <path d="M12 23.48V6.867M9.75 23.481h4.5M11.342.75c6.08-.086 9.929 3.74 10.575 4.403l-1.098 1.419h-2.93l-1.098-1.375M11.342.75C5.802.838 2.262 4.11 1.5 4.85l1.316 1.724h2.85l1.17-1.342m4.506-4.48c-.576.328-2.136 1.454-2.906 2.264-.598.63-1.204 1.444-1.6 2.216m0 0 1.302 1.342h7.511l1.142-1.375m0 0a9.685 9.685 0 0 0-1.54-2.183c-.77-.81-2.33-1.936-2.906-2.264M3.75 15l.75 5.5h3.75V24m12-9-.75 5.5h-3.75V24m3.75-3.375V24m-15-3.375V24m12.75-6.75-10.5-.002 10.5.006v-.004Z" />
  </svg>
);

export const IconHairDryer = () => (
  <svg viewBox="0 0 24 24">
    <path d="m16.566 8.63 2.098 1.109V2.293l-2.098.982c-4.492-.75-7.61-1.3-9.03-1.617a6.308 6.308 0 0 0-1.255-.153c-.595-.014-1.8-.04-2.855.611C1.77 3.146 1.538 5.2 1.511 5.48 1.5 5.602 1.33 7.7 2.866 9.292a4.363 4.363 0 0 0 4.409 1.229l9.291-1.891Z" />
    <path d="m2.867 9.292 1.558 9.217h2.966l-.116-7.988M16.566 8.63V3.275M5.468 22.811c.062-.051.63-.539.587-1.336-.028-.535-.53-.695-.684-1.239-.102-.358-.078-.907.5-1.727M19.597 3.438c.596.592.993.667 1.255.605.337-.08.438-.383.815-.466.377-.082.752.122 1.024.326M19.597 7.603c.596.591.993.667 1.255.604.337-.08.438-.382.815-.464.377-.083.752.121 1.024.325M19.597 5.472c.596.592.993.667 1.255.605.337-.08.438-.383.815-.466.377-.083.752.122 1.024.326M5.401 7.603a1.547 1.547 0 1 0 0-3.094 1.547 1.547 0 0 0 0 3.094Z" />
  </svg>
);

export const IconStar = () => (
  <svg viewBox="0 0 25 25">
    <path d="m12.5 2.814 3.245 6.574L23 10.443l-5.25 5.117 1.239 7.226-6.489-3.411-6.489 3.411L7.25 15.56 2 10.443l7.255-1.055L12.5 2.814Z" />
  </svg>
);
